import { render, staticRenderFns } from "./UploadImg.vue?vue&type=template&id=2e7b3484&scoped=true"
import script from "./UploadImg.vue?vue&type=script&lang=ts"
export * from "./UploadImg.vue?vue&type=script&lang=ts"
import style0 from "./UploadImg.vue?vue&type=style&index=0&id=2e7b3484&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e7b3484",
  null
  
)

export default component.exports